import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import ApplicationLayoutBodyBanner from '@rio-cloud/rio-uikit/ApplicationLayoutBodyBanner';
import { UserSettingsDialog } from './UserSettingsDialog';
import { IFrameWindow } from '../../../../configuration/types';
import { hideSettingsDialog, isMaintenanceMode } from '../../appSlice';
import { useAppDispatch, useAppSelector } from '../../../../configuration/setup/hooks';

export const UserSettingsDialogWrapper: React.FC = () => {
    const isInMaintenanceMode = useAppSelector(isMaintenanceMode);

    const dispatch = useAppDispatch();

    const closeDialog = () => {
        if ('parentIFrame' in window) {
            (window as IFrameWindow).parentIFrame.sendMessage({
                type: 'IFRAME_CLOSE_DIALOG',
            });
        } else {
            dispatch(hideSettingsDialog());
        }
    };

    const renderHeader = () => (
        <div className={'modal-header'}>
            <div className="modal-header-text">
                <div className="modal-header-title">
                    <FormattedMessage id={'intl-msg:settingsDialog.title'} />
                </div>
            </div>
            <div className="modal-header-buttons">
                <button
                    type="button"
                    className={'btn btn-icon-only btn-muted modal-header-close close'}
                    onClick={closeDialog}
                >
                    <span className="rioglyph rioglyph-remove" />
                </button>
            </div>
        </div>
    );

    const banner = isInMaintenanceMode ? (
        <ApplicationLayoutBodyBanner className={'text-center'}>
            <FormattedMessage id={'intl-msg:maintenanceMode'} />
        </ApplicationLayoutBodyBanner>
    ) : null;

    return (
        <div className={'modal-content margin-0'}>
            {banner}
            {renderHeader()}
            <div className={'modal-body padding-top-15'}>
                <UserSettingsDialog />
            </div>
        </div>
    );
};
